<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs headline="Học viên" :link="[{ text: 'Học viên', href: '../students' }]" />
      </div>

      <div class="d-flex">
        <v-btn
          color="primary"
          @click="onClickUpsertGraduation()"
          v-if="['super_admin', 'education_manager'].includes(role.type)"
          ><v-icon left>add</v-icon>{{ addButtonText }}</v-btn
        >
        <student-list-actions
          v-if="['super_admin', 'education_manager'].includes(role.type)"
          :selected="selected"
          @removed="selected = []"
          :filter="draw"
          @filter="draw = !draw"
        />
      </div>
    </div>

    <v-card class="pa-2 pa-md-2 mx-md-2">
      <v-row no-gutters>
        <v-col class="text-right pa-0">
          <span v-if="$vuetify.breakpoint.smAndDown">
            <student-filter-dialog @onFilterChanged="refresh" forGraduation />
          </span>
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" icon class="ml-2">
                <v-icon>mdi-settings</v-icon>
              </v-btn>
            </template>
            <v-list class="px-2" dense style="width: 200px">
              <v-list-item
                v-show="header.configurable"
                dense
                v-for="header in headers"
                :key="header.value"
              >
                <v-checkbox
                  class="mt-0"
                  hide-details="auto"
                  small
                  :label="header.text"
                  :input-value="header.show"
                  @change="onToggleHeader(header.value, !header.show)"
                ></v-checkbox
              ></v-list-item> </v-list
          ></v-menu>
          <span v-if="$vuetify.breakpoint.mdAndUp">
            <drop-menu>
              <export-excel :custom-header="headers" api="/students/" />
            </drop-menu>
          </span>
        </v-col>
      </v-row>
      <student-filter
        ref="studentFilter"
        v-if="$vuetify.breakpoint.mdAndUp"
        @onFilterChanged="refresh"
        forGraduation
      />
      forGraduation
      <v-data-table
        :dense="true"
        item-key="id"
        disableSort
        :headers="visibleHeaders"
        :items="tableData"
        hide-default-footer
        :disable-pagination="true"
      >
        <template v-slot:no-data="">Chưa có học viên tốt nghiệp nào </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn icon small @click.stop="onClickUpsertGraduation(item)">
              <v-icon v-if="canEdit" small> mdi-pencil</v-icon>
              <v-icon v-else small> mdi-eye</v-icon>
            </v-btn>
            <v-btn v-if="canEdit" icon small @click.stop="onClickDeleteGraduation(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.rank="{ value }">
          {{ getRankLabel(value) }}
        </template>
        <template v-slot:item.overall_average="{ value }">
          <span v-if="value">{{ value }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.student.name="{ item }">
          <card-student-name :student="item.student" link />
        </template>

        <template v-slot:item.start_date="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.end_date="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.certificate_date_monster_lab="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.certificate_date_cc_training="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.certificate_date_college="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.graduated="{ value }">
          {{ value ? '✓' : '' }}
        </template>
        <template v-slot:item.certificate_date_college="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.student.dob="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.note="{ value }">
          <span v-if="value">{{ value }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.student.majors`]="{ value }">
          <span v-for="(major, index) in value" :key="major.id">
            {{ major.title }}
            <span v-if="index < value.length - 1">{{ ', ' }}</span>
          </span>
        </template>
        <template v-slot:[`item.student.generation`]="{ value }">
          <span style="white-space: nowrap">{{ value ? value.code : '' }}</span>
        </template>
        <template v-slot:[`item.student.gender`]="{ value }">
          <span style="white-space: nowrap">{{ getGenderLabel(value) }}</span>
        </template>
        <template v-slot:top=""> </template>
      </v-data-table>
      <UpsertGraduationDialog
        v-if="upsertGraduationDialog.isOpen"
        :isOpen="upsertGraduationDialog.isOpen"
        :isEdit="upsertGraduationDialog.isEdit"
        :currentItem="upsertGraduationDialog.currentItem"
        @close="upsertGraduationDialog.onCancel"
        @cancel="upsertGraduationDialog.onCancel"
        @confirm="upsertGraduationDialog.callback"
      />
    </v-card>
  </div>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DateSelector from '@/components/basic/DateSelector.vue'
import ExportExcel from '@/components/basic/ExportExcel'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import UpsertGraduationDialog from '@/components/UpsertGraduationDialog.vue'
import {
  getGenderLabel,
  getRankLabel,
  getStudentRankList,
  transformDateForDatePicker
} from '@/helpers'
import DropMenu from '@/modules/student/menu/Menu.vue'
import SingleStudentListActions from '@/modules/student/SingleStudentListActions'
import StudentFilter from '@/modules/student/StudentFilter'
import StudentFilterDialog from '@/modules/student/StudentFilterDialog'
import StudentListActions from '@/modules/student/StudentListActions'
import StudentNewDialog from '@/modules/student/StudentNewDialog'
import { cloneDeep, get, set, unset } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    UpsertGraduationDialog,
    DateSelector,
    AutocompleteStudent,
    BaseDialog,
    CardStudentName,
    DropMenu,
    SingleStudentListActions,
    StudentListActions,
    StudentNewDialog,
    StudentFilter,
    Breadcrumbs,
    SettingTableHeader,
    StudentFilterDialog,
    ExportExcel
  },
  props: {
    role: String
  },
  data() {
    return {
      upsertGraduationDialog: {
        currentItem: null,
        isEdit: false,
        isOpen: false,
        callback: () => {},
        onCancel: () => {
          this.upsertGraduationDialog.isOpen = false
          this.upsertGraduationDialog.isEdit = false
          this.upsertGraduationDialog.currentItem = null
        }
      },
      headers: [
        {
          text: 'STT',
          value: 'index',
          align: 'left',
          sortable: false,
          show: true,
          configurable: false,
          width: 56
        },
        {
          text: 'Tên',
          value: 'student.name',
          align: 'left',
          sortable: false,
          show: true,
          configurable: false,
          width: 200
        },
        {
          text: 'Lớp',
          value: 'student.tags',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Chuyên ngành',
          value: 'student.majors',
          align: 'left',
          sortable: false,
          configurable: true,
          show: true,
          width: 400
        },
        {
          text: 'Khóa',
          value: 'student.generation',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Ngày sinh',
          value: 'student.dob',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Giới tính',
          value: 'student.gender',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Thời gian nhập học',
          value: 'start_date',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Thời gian hoàn thành chương trình',
          value: 'end_date',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Điểm trung bình toàn khóa',
          value: 'overall_average',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Xếp loại tốt nghiệp Hệ Mons',
          value: 'rank',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Số vào sổ cấp bằng',
          value: 'certificate_number',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Ngày nhận bằng Monster Lab',
          value: 'certificate_date_monster_lab',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Ngày nhận CC sơ cấp/ CC đào tạo',
          value: 'certificate_date_cc_training',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Ngày nhận bằng Hệ Cao đẳng',
          value: 'certificate_date_college',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Bằng CDNT',
          value: 'college_certificate_cdnt',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Đã tốt nghiệp',
          value: 'graduated',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'SĐT',
          value: 'student.phone',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Email',
          value: 'student.email',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Ghi chú',
          value: 'note',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Hành động',
          value: 'actions',
          align: 'left',
          sortable: false,
          configurable: false,
          show: true
        }
      ],
      selected: [],
      draw: false,
      search: '',
      loading: false,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      studentTableOptions: {},
      onCreate: false,
      selectedStudent: {}
    }
  },
  async created() {
    this.loadDataOnCreated()
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role']),
    ...mapState('graduation', ['graduations']),
    getStudentRankList,
    visibleHeaders() {
      return this.headers.filter(i => i.show)
    },

    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },

    typeQueryParam() {
      return get(this.$route.query, 'type', 'long_term')
    },
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm tốt nghiệp'
      }
    },
    tableData() {
      let output = this.graduations.map(({ student, ...o }, index) => ({
        student,
        ...o,
        index: index + 1
      }))

      return output
    }
  },
  methods: {
    ...mapActions('student', ['fetchStudent']),

    ...mapActions('graduation', [
      'fetchGraduations',
      'createGraduation',
      'updateGraduation',
      'removeGraduation'
    ]),
    getGenderLabel,
    transformDateForDatePicker,
    getRankLabel,

    formatDateField(v) {
      if (!v) {
        return v
      }
      return moment(v).format('DD/MM/YYYY')
    },
    onToggleHeader(key, value) {
      this.headers = this.headers.map(i => {
        if (i.value === key) {
          return { ...i, show: value }
        }
        return i
      })
    },
    async refresh(query) {
      unset(query, ['type'])
      unset(query, ['status'])
      this.loading = true
      const { _sort, start_date_gte, start_date_lte, end_date_gte, end_date_lte, rank, ...o } =
        query

      const trueQuery = { _sort, start_date_gte, start_date_lte, end_date_gte, end_date_lte, rank }
      Object.entries(o).map(([k, v]) => {
        trueQuery[`student[${k}]`] = v
      })
      await this.fetchGraduations(trueQuery)
      this.loading = false
    },
    async loadDataOnCreated() {
      await this.fetchGraduations({})
    },
    onClickUpsertGraduation(item) {
      let data = {
        student: '',
        start_date: moment().startOf('day').toISOString(),
        end_date: moment().startOf('day').toISOString(),
        overall_average: '',
        rank: '',
        certificate_number: null,
        certificate_date_monster_lab: null,
        certificate_date_cc_training: null,
        certificate_date_college: null,
        note: ''
      }
      if (item) {
        data = cloneDeep(item)
        data.student = data.student.id
      }
      this.upsertGraduationDialog.currentItem = data
      this.upsertGraduationDialog.isEdit = !!item
      this.upsertGraduationDialog.isOpen = true
      this.upsertGraduationDialog.callback = (async payload => {
        try {
          if (item) {
            await this.updateGraduation({
              id: item.id,
              params: payload
            })
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createGraduation({
              params: payload
            })
            this.$alert.success('Tạo thành công')
          }
          await this.fetchStudent(
            this.upsertGraduationDialog.currentItem.student.id ||
              this.upsertGraduationDialog.currentItem.student
          )
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertGraduationDialog.isOpen = false
          this.upsertGraduationDialog.currentItem = null
        }
      }).bind(this)
    },
    onClickDeleteGraduation(item) {
      this.$dialog.confirm({
        title: 'Xóa tốt nghiệp',
        text: ` Bạn có Chắc Chắn xóa thông tin tốt nghiệp này?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeGraduation({ id: item.id })
          this.$alert.success('Xóa thành công')
          await this.fetchStudent(item.student.id)
        }
      })
    }
  },

  watch: {
    typeQueryParam() {
      this.$refs.studentFilter.reset()
      this.loadDataOnCreated()
    }
  }
}
</script>
<style lang="scss" scoped>
// @import '~vuetify/src/styles/styles.sass';

::v-deep {
  th,
  td {
    background-color: #fff;
  }
  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  th:nth-child(2),
  td:nth-child(2) {
    position: sticky;
    left: 56px;
    z-index: 1;
  }
}
</style>
